import { Page } from '@/core/architecture'

import { PrivacySettingsTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * PrivacySettings Page
 * Implemented as a practical sample.
 */
export const PrivacySettings: Page = () => {
  const { state, actions } = useViewModel()

  return <PrivacySettingsTemplate state={state} {...actions} />
}
